import { useFocusRing } from '@react-aria/focus'

import type { DefaultElementProps } from '@subaio/components'

import { FocusVisibleInset } from 'components/FocusVisible'

import { Check } from '../../Check'
import { CheckCircle } from '../../CheckCircle'
import { Cell } from '../Cell'
import { Row } from './Row'

type Props = {
	isSelected: boolean
	checkboxStyle?: 'circle' | 'plain'

	onClick: (isSelected: boolean) => void
} & DefaultElementProps

export const ItemOption = ({ isSelected, checkboxStyle = 'circle', children, onClick, ...rest }: Props) => {
	const { isFocusVisible, focusProps } = useFocusRing()

	return (
		<Row
			isSelected={isSelected}
			role='checkbox'
			aria-checked={isSelected}
			tabIndex={0}
			// Allow multi-click, since it generally isn't problematic for checkboxes
			allowMultiClick
			{...rest}
			{...focusProps}
			onClick={() => onClick(!isSelected)}
		>
			<FocusVisibleInset isFocusVisible={isFocusVisible} />
			{checkboxStyle === 'circle' && (
				<Cell>
					<CheckCircle isChecked={isSelected} />
				</Cell>
			)}
			{children}
			{checkboxStyle === 'plain' && (
				<Cell right>
					<Check isChecked={isSelected} />
				</Cell>
			)}
		</Row>
	)
}
